(function () {
  'use strict';

  angular.module('wsLrs.services').factory("ShareKeyHelper", ['$routeParams', '$injector', '$location', function ($routeParams, $injector, $location) {
    function getQueryVariable(variable) {
      var url = $location.$$url || window.location.search,
        qsStart = url.indexOf("?");
      if (qsStart === -1) {
        return null;
      }
      var query = url.substring(qsStart + 1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      return null;
    }
    function getShareKey() {
      if ($routeParams.shareKey) {
        //Normal case
        return $routeParams.shareKey;
      }
      var qsShareKey = getQueryVariable("shareKey");
      if (qsShareKey !== null) {
        // Weird case in embedding when $routeParams didn't init upon refresh
        return qsShareKey;
      }
      var route = $injector.get('$route');
      if (route.current && route.current.params.shareKey) {
        //If we're in the middle of resolving the route
        return route.current.params.shareKey;
      }
      if ($location.path().indexOf("/share", 0) !== -1 || $location.path().indexOf("/tableau", 0) !== -1) {
        //If we're in app.js
        var path = $location.path();
        var startOfShare = path.indexOf("/", 1) + 1,
          endOfShare = path.indexOf("/", startOfShare),
          share = path.substring(startOfShare, endOfShare > 0 ? endOfShare : undefined);
        return share;
      }
      return null;
    }
    return {
      getShareKey: getShareKey,
      hasShareKey: function hasShareKey() {
        return getShareKey() !== null;
      }
    };
  }]).factory("ShareUtils", ['$routeParams', '$http', '$q', 'Config', 'Utils', 'ShareKeyHelper', function ($routeParams, $http, $q, Config, Utils, ShareKeyHelper) {
    var shares = {};
    function getShare(shareKey) {
      var deferred = $q.defer();
      var id = shareKey || ShareKeyHelper.getShareKey();
      if (id === "shares") {
        deferred.resolve(null);
        return deferred.promise;
      }
      if (id in shares) {
        deferred.resolve(shares[id]);
        return deferred.promise;
      }
      if (id) {
        var token = Utils.getQueryVariable("token");
        var requestConfig = token ? {
          headers: {
            "Authorization": "Bearer " + token
          }
        } : null;
        var apiRoot = Config.get().apiUrl;
        return $http.get(apiRoot + "/shares/by-share-key/" + id, requestConfig).then(function (response) {
          shares[id] = response.data;
          return response.data;
        });
      }
      deferred.resolve(null);
      return deferred.promise;
    }
    return {
      //Transparent alias so that people who want ShareUtils don't also have to get ShareKeyHelper
      getShareKey: ShareKeyHelper.getShareKey,
      hasShareKey: ShareKeyHelper.hasShareKey,
      getShare: getShare,
      //There should always be a share during the lifespan of a page because loading cards will set it.
      getCachedShare: function getCachedShare(shareKey) {
        var id = shareKey || ShareKeyHelper.getShareKey();
        if (id in shares) {
          return shares[id];
        }
        return null;
      },
      getCard: function getCard(shareKey) {
        return getShare(shareKey).then(function (data) {
          return data.card;
        });
      },
      getCardWithToken: function getCardWithToken(shareKey) {
        return getShare(shareKey);
      },
      getUser: function getUser(shareKey) {
        return getShare(shareKey).then(function (data) {
          return data.user;
        });
      },
      getShares: function getShares() {
        return shares;
      },
      sharingEnabled: function sharingEnabled(card) {
        return card.template.sharingEnabled;
      }
    };
  }]).
  //Pulled out so it can access both Api and ShareUtils
  factory("ShareNav", ['Api', '$http', '$uibModal', 'ShareUtils', '$location', '$q', 'OrganizationSettings', 'CardRegistry', function (Api, $http, $uibModal, ShareUtils, $location, $q, OrganizationSettings, CardRegistry) {
    return {
      shareCard: function shareCard($scope) {
        return {
          createShareModal: function createShareModal(cardId) {
            $scope.cardId = cardId || $scope.cardId;
            $scope.createShareModal = $uibModal.open({
              templateUrl: "modules/app/shares/modals/create-share-modal.html",
              controller: "CreateShareCtrl",
              scope: $scope,
              size: "lg"
            });
          }
        };
      },
      updateNav: function updateNav($scope) {
        var card = $scope.card;
        var self = this;
        if (_.isEmpty($scope.card) && $scope.cardId) {
          card = CardRegistry.get($scope.cardId);
        }
        if (!card || !card.template.sharingEnabled) {
          var deferred = $q.defer();
          deferred.resolve(false);
          return deferred.promise;
        }
        return ShareUtils.getShare().then(function (share) {
          function getSettings() {
            if (share) {
              return OrganizationSettings.getForOrganization(share.card.organization.id);
            }
            return OrganizationSettings.get();
          }
          return getSettings().then(_.bind(function (response) {
            var sharingEnabled = response && response.sharingEnabled;
            if (ShareUtils.hasShareKey()) {
              if (sharingEnabled) {
                return ShareUtils.getShare().then(function (share) {
                  return {
                    text: "Shared by " + share.user.name
                  };
                });
              }
            } else if (sharingEnabled && OrganizationSettings.hasFeature("shareSnapshot")) {
              return {
                text: OrganizationSettings.hasFeature("embed") ? "Share & Embed" : "Share",
                href: null,
                tooltip: "Share",
                callback: self.shareCard($scope).createShareModal,
                share: true
              };
            }
          }, this));
        });
      }
    };
  }]);
})();
